export default __webpack_public_path__ + "static/media/Stone.256.1876444c.png";